/**
 * First Run Modal Controller
 *
 * Manages the first-run welcome modal
 * @module portal/modules/ui/modals/firstRunModal
 */

import { els } from '../elements';

/**
 * Close the first run welcome modal
 */
export function closeFirstRunModal(): void {
  if (!els.firstRunModal) return;
  els.firstRunModal.hidden = true;
  document.body.classList.remove('modal-open');
}
